// routes.js
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
const Home = lazy(() => import('../pages/home'));
const PageNotFound = lazy(() => import('../pages/pagenotfound'));
const Ingresos = lazy(() => import('../pages/Steps/Ingresos'));
const Egresos = lazy(() => import('../pages/Steps/Egresos'));
const Garantias = lazy(() => import('../pages/Steps/Garantias'));
const DetallesPrestamo = lazy(() => import('../pages/Steps/DetallesPrestamo'));
const Confirm = lazy(() => import('../pages/Steps/Confirm'));
const Steeper = lazy(() => import('../pages/Steps/Steeper'));


// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

const RouterConfig = [
    {
        path: '/',
        children: [
            { path: '/', exact: true, element: <Home /> },
            { path: '/form', element: <Steeper /> }, // Ruta para la página 404
            { path: '/ingresos', element: <Ingresos /> }, // Ruta para la página 404
            { path: '/egresos', element: <Egresos /> }, // Ruta para la página 404
            { path: '/garantias', element: <Garantias /> }, // Ruta para la página 404
            { path: '/detallesPrestamo', element: <DetallesPrestamo /> }, // Ruta para la página 404
            { path: '/confirm', element: <Confirm /> }, // Ruta para la página 404
            { path: '/404', element: <PageNotFound /> }, // Ruta para la página 404
            { path: '*', element: <Navigate to="/404" replace /> }
        ],
    }
];

export default RouterConfig;